module.exports = __webpack_public_path__ + "static/img/application2-4.30970b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-4.jpg
// module id = 1uMB
// module chunks = 0